export default {
  cmsHost: process.env.NEXT_PUBLIC_CMS_HOST,
  tileServerUrl: process.env.NEXT_PUBLIC_TILE_SERVER_URL,
  tileServerAccessToken: process.env.NEXT_PUBLIC_TILE_SERVER_ACCESS_TOKEN,
  tileServerId: process.env.NEXT_PUBLIC_TILE_SERVER_ID,
};
